import type { ReactNode } from 'react'

import { IconChevronRight } from '@tabler/icons-react'

import { ChevronWrapper } from './ChevronWrapper'
import { Container } from './Container'
import { Header } from './Header'
import { IconWrapper } from './IconWrapper'
import { Title } from './Title'

type Props = {
	title: string
	name: string
	fragment?: string
	icon?: ReactNode
	children: ReactNode
}

export const NavigationCard = ({ title, name, fragment, icon, children }: Props) => (
	<Container name={name} fragment={fragment}>
		<Header>
			{Boolean(icon) && <IconWrapper>{icon}</IconWrapper>}
			<Title>{title}</Title>
			<ChevronWrapper>
				<IconChevronRight size={14} />
			</ChevronWrapper>
		</Header>
		<div>
			<div>{children}</div>
		</div>
	</Container>
)
